const sicpe = {
    GetPersonas: 'SICPE/Registro',
  }
  export default sicpe;
  


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/funcion/sicpe.js
// module id = null
// module chunks = 